export enum ToastType {
    success = 'Success',
    info = 'Info',
    warning = 'Warning',
    error = 'Error',
}